import { render } from "./manage-service.vue?vue&type=template&id=34311478"
import script from "./manage-service.vue?vue&type=script&lang=js"
export * from "./manage-service.vue?vue&type=script&lang=js"

import "./manage-service.vue?vue&type=style&index=0&id=34311478&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__